import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import {
  convertDataNameOrgById,
  handelConvertDataTagById,
  handelGetAllPort,
  handleSelectCheckBox,
} from '../filterSetting/helper'
import {
  getCompanies,
  getSearchExcludeCompanyInPortfolio,
  getSearchPortfolioAllInSetting,
  getSearchPortfolioInSetting,
} from './thunk'

const initialState = {
  dataSearchPortfolio: [],
  listSelectedPort: [],
  isAll: null,
  dataSearchCompanyExclude: [],
  listSelectedCompanyExclude: [],
  dataAllPortfolio: [],
  loading: {
    searchPort: true,
    searchCompany: true,
    getAllPort: true,
    getCompanies: false,
  },
  textSearch: '',
  textSearchCompany: '',
}

const slice = createSlice({
  name: 'common/filterCompany/portfolio',
  initialState,
  reducers: {
    resetStorePortfolio: () => initialState,
    changeListSelected: (state, action) => {
      state.listSelectedPort = handleSelectCheckBox(
        state.listSelectedPort,
        action.payload,
      )
    },
    changeListSelectedCompany: (state, action) => {
      state.listSelectedCompanyExclude = handleSelectCheckBox(
        state.listSelectedCompanyExclude,
        action.payload,
      )
    },
    changeTextSearch: (state, action) => {
      state.textSearch = action.payload
    },
    changeTextSearchCompany: (state, action) => {
      state.textSearchCompany = action.payload
    },
    handleCheckAllPort: (state) => {
      if (state.isAll === true) {
        state.listSelectedPort = []
        state.isAll = false
      } else {
        state.listSelectedPort = state.dataAllPortfolio
        state.isAll = true
      }
    },
    changeTypeCheckPort: (state, action) => {
      state.isAll = action.payload
    },
    covertDataPortById: (state, action) => {
      if (action.payload.length === 0) {
        state.listSelectedPort = state.dataAllPortfolio
        state.isAll = true
      } else {
        state.isAll = action.payload.length === state.dataAllPortfolio.length
        state.listSelectedPort = handelConvertDataTagById(
          action.payload,
          state.dataAllPortfolio,
        )
      }
    },
    resetPortfolio: (state, action) => {
      Object.keys(initialState).forEach((key) => {
        if (['dataAllPortfolio', 'loading'].includes(key)) return
        if (key === 'listSelectedPort') {
          state.listSelectedPort = state.dataAllPortfolio
          return
        }
        if (key === 'isAll') {
          state.isAll = true
          return
        }
        state[key] = initialState[key]
      })
    },
  },
  extraReducers: (builder) => {
    //
    builder.addCase(getSearchPortfolioInSetting.pending, (state) => {
      state.loading.searchPort = true
    })
    builder.addCase(getSearchPortfolioInSetting.fulfilled, (state, action) => {
      state.dataSearchPortfolio = action.payload
      state.loading.searchPort = false
    })
    builder.addCase(getSearchPortfolioInSetting.rejected, (state, action) => {
      state.dataSearchPortfolio = []
      state.loading.searchPort = action.payload.loading
    })
    //getSearchExcludeCompanyInPortfolio
    builder.addCase(getSearchExcludeCompanyInPortfolio.pending, (state) => {
      state.loading.searchCompany = true
    })
    builder.addCase(
      getSearchExcludeCompanyInPortfolio.fulfilled,
      (state, action) => {
        state.dataSearchCompanyExclude = action.payload
        state.loading.searchCompany = false
      },
    )
    builder.addCase(
      getSearchExcludeCompanyInPortfolio.rejected,
      (state, action) => {
        state.dataSearchCompanyExclude = []
        state.loading.searchCompany = action.payload.loading
      },
    )
    //getAll getSearchPortfolioAllInSetting
    builder.addCase(getSearchPortfolioAllInSetting.pending, (state) => {
      state.loading.getAllPort = true
    })
    builder.addCase(
      getSearchPortfolioAllInSetting.fulfilled,
      (state, action) => {
        state.dataAllPortfolio = handelGetAllPort(action.payload)
        state.loading.getAllPort = false
      },
    )
    builder.addCase(
      getSearchPortfolioAllInSetting.rejected,
      (state, action) => {
        state.dataSearchPortfolio = []
        state.loading.getAllPort = action.payload.loading
      },
    )
    //getCompanies
    builder.addCase(getCompanies.pending, (state) => {
      state.loading.getCompanies = true
    })
    builder.addCase(getCompanies.fulfilled, (state, action) => {
      state.listSelectedCompanyExclude = convertDataNameOrgById(action.payload)
      state.loading.getCompanies = false
    })
    builder.addCase(getCompanies.rejected, (state, action) => {
      state.listSelectedCompanyExclude = []
      state.loading.getCompanies = action.payload.loading
    })
  },
})

export const loadingPortfolio = (type) => (state) =>
  state[slice.name].loading[type]

export const selectDataSearchPortfolio = (state) =>
  state[slice.name].dataSearchPortfolio
export const selectDataPortfolioAll = (state) =>
  state[slice.name].dataAllPortfolio
export const selectListSelected = (state) => state[slice.name].listSelectedPort
export const selectIsAllCheck = (state) => state[slice.name].isAll

export const selectDataSearchCompanyExclude = (state) =>
  state[slice.name].dataSearchCompanyExclude
export const selectListSelectedCompanyExclude = (state) =>
  state[slice.name].listSelectedCompanyExclude

export const selectTextSearch = (state) => state[slice.name].textSearch
export const selectTextSearchCompany = (state) =>
  state[slice.name].textSearchCompany

export const {
  resetStorePortfolio,
  changeListSelected,
  changeTextSearch,
  resetPortfolio,
  changeTextSearchCompany,
  changeListSelectedCompany,
  handleCheckAllPort,
  changeTypeCheckPort,
  covertDataPortById,
} = slice.actions

register(slice.name, slice.reducer)
